import { useState } from 'react';
import Icon from '../components/Icon.jsx';
import { branches } from '../data.js';

export default function BranchesSlide() {
  const [selected, setSelected] = useState(0);
  return (
    <section className="slide-content branches-slide">
      <div className="branches-heading reveal-stack">
        <div className="eyebrow dark"><Icon name="map" />UAE Map</div>
        <h2>Our Locations and branches:</h2>
      </div>
      <div className="branches-composition">
        <div className="uae-map-stage">
          <div className="uae-map-glow" />
          <div className="uae-map-shape" aria-label="United Arab Emirates map" />
          <div className="uae-map-scan" />
          {branches.map((branch, index) => (
            <button
              className={`branch-pin ${selected === index ? 'is-active' : ''} ${branch.labelSide === 'left' ? 'is-left' : 'is-right'}`}
              key={branch.name}
              style={{ left: `${branch.x}%`, top: `${branch.y}%` }}
              onMouseEnter={() => setSelected(index)}
              onFocus={() => setSelected(index)}
              onClick={() => setSelected(index)}
              aria-label={branch.name}
            >
              <i /><span>{branch.name}</span>
            </button>
          ))}
          <div className="branch-radar radar-a" /><div className="branch-radar radar-b" />
        </div>
        <aside className="branch-directory">
          <div className="branch-directory-head">
            <small>ACTIVE LOCATION</small>
            <h3>{branches[selected].name}</h3>
          </div>
          <div className="branch-list">
            {branches.map((branch, index) => (
              <button className={selected === index ? 'is-active' : ''} key={branch.name} onClick={() => setSelected(index)}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                <b>{branch.name}</b>
                <i />
              </button>
            ))}
          </div>
          <div className="branch-signature">Rana Titi</div>
        </aside>
      </div>
    </section>
  );
}
